import { Heading } from 'Components/shared/Heading';
import styled from 'styled-components';

const Wrapper = styled.div`
  overflow: hidden;
`;

const StyledHeading = styled(Heading)`
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Emoji = styled.span`
  margin-left: ${({ theme }) => theme.sizes.xsmall};
  font-size: ${({ theme }) => theme.sizes.small};
`;

export const Styled = {
  Wrapper,
  Heading: StyledHeading,
  Emoji,
};
